import React from 'react';

import Table from 'components/Table';

import { useWorkoutTemplatesColumns } from './columns/useWorkoutTemplatesColumns';
import ModalWorkoutTemplateDelete from './ModalWorkoutTemplateDelete';
import type { WorkoutTemplatesTableContainerProps } from './types';
import { useWorkoutTemplatesTable } from './useWorkoutTemplatesTable';
import ModalWorkoutTemplatePreview from '../ModalWorkoutTemplatePreview';

const WorkoutTemplatesTableContainer = (props: WorkoutTemplatesTableContainerProps): JSX.Element => {
  const { tableData, columnsInput, tableProps, deleteModal, previewModal } = useWorkoutTemplatesTable(props);

  const columns = useWorkoutTemplatesColumns(columnsInput);

  return (
    <>
      <ModalWorkoutTemplateDelete
        opened={deleteModal.opened}
        template={deleteModal.template}
        handleClose={deleteModal.onClose}
      />
      <ModalWorkoutTemplatePreview
        opened={previewModal.opened}
        template={previewModal.template}
        handleClose={previewModal.onClose}
        showEditButton={props.permission}
      />
      <Table fillHeight tableData={tableData} columns={columns} {...tableProps} />
    </>
  );
};

export default WorkoutTemplatesTableContainer;
